export default "__VITE_PUBLIC_ASSET__66291ae1__"